// Sinh id duy nhất cho thẻ / bài — NGẮN GỌN (8 ký tự) để URL/id không dài lê thê.
// vd: lesson_f8f98511 thay vì lesson_<uuid đầy đủ>.
export function genId(prefix = 'card'): string {
  const base =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '')
      : Math.random().toString(36).slice(2) + Date.now().toString(36)
  return `${prefix}_${base.slice(0, 8)}`
}

// Tạo slug thân thiện URL từ tiêu đề tiếng Việt.
export function slugify(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // bỏ dấu thanh tiếng Việt
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
}
